function e() {
  return typeof window < "u";
}
export {
  e as isBrowser
};
//# sourceMappingURL=index124.js.map
